/* sizechart.js — đảm bảo: khi mở 1 details thì đóng hết details khác + tab logic */
(function(){
  "use strict";

  function initForRoot(root){
    if(!root || root.__sc_inited) return;
    root.__sc_inited = true;

    // tạo tab panels cho mỗi details nếu có 2 tables
    Array.from(root.querySelectorAll('details')).forEach(function(det){
      det.removeAttribute('open'); // default closed
      var tables = det.querySelectorAll('table');
      if(tables.length >= 2){
        if(det.querySelector('.tabs')) return; // đã xử lý
        var tabWrap = document.createElement('div'); tabWrap.className = 'tabs';
        var btn1 = document.createElement('button'); btn1.className='tab-btn active'; btn1.type='button'; btn1.innerText='INCHES';
        var btn2 = document.createElement('button'); btn2.className='tab-btn'; btn2.type='button'; btn2.innerText='CENTIMETERS';
        var p1 = document.createElement('div'); p1.className='tab-panel active';
        var p2 = document.createElement('div'); p2.className='tab-panel';

        var t0 = tables[0], t1 = tables[1];
        var h0 = t0.previousElementSibling && t0.previousElementSibling.tagName.toLowerCase()==='h3' ? t0.previousElementSibling : null;
        var h1 = t1.previousElementSibling && t1.previousElementSibling.tagName.toLowerCase()==='h3' ? t1.previousElementSibling : null;
        if(h0) p1.appendChild(h0);
        p1.appendChild(t0);
        if(h1) p2.appendChild(h1);
        p2.appendChild(t1);

        btn1.addEventListener('click', function(){ btn1.classList.add('active'); btn2.classList.remove('active'); p1.classList.add('active'); p2.classList.remove('active'); });
        btn2.addEventListener('click', function(){ btn2.classList.add('active'); btn1.classList.remove('active'); p2.classList.add('active'); p1.classList.remove('active'); });

        tabWrap.appendChild(btn1); tabWrap.appendChild(btn2);
        var summary = det.querySelector('summary');
        if(summary){
          det.insertBefore(tabWrap, summary.nextSibling);
          det.insertBefore(p1, tabWrap.nextSibling);
          det.insertBefore(p2, p1.nextSibling);
        }
        // remove duplicate stray tables if any left
        Array.from(det.querySelectorAll('table')).forEach(function(tt){
          if(tt.parentNode && tt.parentNode !== p1 && tt.parentNode !== p2){
            tt.parentNode.removeChild(tt);
          }
        });
      }
    });

    // Khi 1 details mở => đóng tất cả details khác (bắt chắc bằng cả click + toggle)
    // (1) toggle: bắt sự kiện thay đổi trạng thái (works with programmatic open)
    root.addEventListener('toggle', function(e){
      var d = e.target;
      if(d && d.tagName && d.tagName.toLowerCase()==='details' && d.open){
        Array.from(root.querySelectorAll('details')).forEach(function(other){
          if(other !== d) other.removeAttribute('open');
        });
      }
    }, true);

    // (2) click/key handlers trên <summary> để xử lý native toggle race condition
    root.addEventListener('click', function(ev){
      var s = ev.target.closest && ev.target.closest('summary');
      if(!s) return;
      var det = s.parentElement;
      // setTimeout nhỏ để đợi browser cập nhật det.open (native toggle) rồi đóng others
      setTimeout(function(){
        if(det.open){
          Array.from(root.querySelectorAll('details')).forEach(function(other){
            if(other !== det) other.removeAttribute('open');
          });
        } else {
          // nếu vừa click để đóng thì không cần làm gì
        }
      }, 20);
    }, true);

    // keyboard accessibility: Enter / Space on summary
    root.addEventListener('keydown', function(ev){
      var s = ev.target;
      if(s && s.tagName && s.tagName.toLowerCase()==='summary' && (ev.key==='Enter' || ev.key===' ')){
        // allow native behavior then handle closing others
        setTimeout(function(){
          var det = s.parentElement;
          if(det && det.open){
            Array.from(root.querySelectorAll('details')).forEach(function(other){
              if(other !== det) other.removeAttribute('open');
            });
          }
        }, 20);
      }
    }, true);
  }

  // init when element appears (MutationObserver)
  function tryInit(){
    var r = document.querySelector('#size-chart') || document.querySelector('.tpo_modal-content.ql-editor #size-chart');
    if(r) initForRoot(r);
  }

  var mo = new MutationObserver(function(){ tryInit(); });
  mo.observe(document.documentElement || document.body, { childList:true, subtree:true });

  window.addEventListener('load', tryInit);
  // also try now
  tryInit();

})();
